interface SeoProps {
  title: string;
  description: string;
  keywords?: string;
  ogImage?: string;
}

export default function Seo({ title, description, keywords, ogImage }: SeoProps) {
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {ogImage ? <meta property="og:image" content={ogImage} /> : null}
    </>
  );
}